export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "صفحه ورود",
      guestRequired: true,
    },
  },

  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      title: "پنل مدیریت",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/dashboard/index.vue"),
  },

  {
    path: "/builders",
    name: "builders-management",
    meta: {
      title: "مدیریت سازندگان",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/builders/index.vue"),
  },

  {
    path: "/factories",
    name: "factories-management",
    meta: {
      title: "مدیریت کارخانه ها",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/factories/index.vue"),
  },

  {
    path: "/factories/add",
    name: "factory.add",
    meta: {
      title: "افزودن کارخانه جدید",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/factories/FactoryAdd.vue"),
  },

  {
    path: "/factories/edit/:id",
    name: "factory.edit",
    meta: {
      title: "ویرایش کارخانه",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/factories/FactoryEdit.vue"),
  },

  {
    path: "/factories/:id",
    name: "factory.detail",
    meta: {
      title: "جزئیات کارخانه",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/factories/FactoryDetail.vue"),
  },

  {
    path: "/orders",
    name: "orders-management",
    meta: {
      title: "مدیریت درخواست‌های خرید",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/orders/index.vue"),
  },

  {
    path: "/orders/:id",
    name: "order.detail",
    meta: {
      title: "جزئیات سفارش",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/orders/OrderDetail.vue"),
  },

  {
    path: "/dashboard/reviews",
    name: "reviews",
    meta: {
      title: "نظرات",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/reviews/index.vue"),
  },

  {
    path: "/dashboard/tickets",
    name: "builder-tickets",
    meta: {
      title: "تیکت سازندگان",
      authRequired: true,
      isAdmin: true,
      ticketKind: "builder",
    },
    component: () => import("../views/tickets/index.vue"),
  },

  {
    path: "/dashboard/tickets/:id",
    name: "builder-ticket-details",
    meta: {
      title: "جزئیات تیکت سازنده",
      authRequired: true,
      isAdmin: true,
      ticketKind: "builder",
    },
    component: () => import("../views/tickets/show.vue"),
  },

  {
    path: "/hero",
    name: "hero-management",
    meta: {
      title: "مدیریت بخش Hero",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/heroes/hero.vue"),
  },

  {
    path: "/hero-slides",
    name: "hero-slides-management",
    meta: {
      title: "مدیریت اسلایدر Hero",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/hero-slides/index.vue"),
  },

  {
    path: "/plans",
    name: "plans-management",
    meta: {
      title: "مدیریت بخش پلن ها",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/plans/index.vue"),
  },

  {
    path: "/testimonials",
    name: "testimonials-management",
    meta: {
      title: "مدیریت نظرات مشتریان",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/testimonials/index.vue"),
  },

  {
    path: "/faqs",
    name: "faqs-management",
    meta: {
      title: "مدیریت پرسش های متداول",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/faqs/index.vue"),
  },

  {
    path: "/galleries",
    name: "galleries-management",
    meta: {
      title: "مدیریت گالری تصاویر",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/galleries/index.vue"),
  },

  {
    path: "/settings/pricing",
    name: "pricing-settings",
    meta: {
      title: "تنظیمات قیمت",
      authRequired: true,
      isAdmin: true,
    },
    component: () => import("../views/pricing-settings/index.vue"),
  },
]